import { render } from "./UIBtnSecondary.vue?vue&type=template&id=093f463b&scoped=true&ts=true"
import script from "./UIBtnSecondary.vue?vue&type=script&lang=ts"
export * from "./UIBtnSecondary.vue?vue&type=script&lang=ts"

import "./UIBtnSecondary.vue?vue&type=style&index=0&id=093f463b&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093f463b"]])

export default __exports__